import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../../common-components";

const AccountScannerPopUp = ({
  setClose,
  companyInformation,
  auth,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setLoading,
}) => {
  const [offItem, setOffItem] = useState(true);
  const [accountData, setAccountData] = useState(null);

  const [passwordSecure, setPasswordSecure] = useState(null);

  const [requestPasswordPopUp, setRequestPasswordPopUp] = useState(false);

  //varibles for input data
  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");

  const [passwordCheck, setPasswordCheck] = useState("");

  // create new account function
  const createNewScannerAccount = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/createScannerUser",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            businessId: companyInformation.companyId,
            buisnessName: companyInformation.companyName,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // setCompanyInformation(respnseData.companyInfo);
        setAccountData(respnseData.user);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(respnseData.success);
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  // get exitsing account

  const getAgecncyScannerUser = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getScannerUserInfo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            businessId: companyInformation.companyId,
            buisnessName: companyInformation.companyName,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // setCompanyInformation(respnseData.companyInfo);
        setAccountData(respnseData.agencyUser);
        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  // get password after security check
  const showPassword = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/agency/getPassowrdToshow",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            businessId: companyInformation.companyId,
            userId: auth.userId,
            password: passwordCheck,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setRequestPasswordPopUp(false);
        setPasswordSecure(respnseData.isValidPassword);
        // setCompanyInformation(respnseData.companyInfo);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  useEffect(() => {
    if (companyInformation) {
      getAgecncyScannerUser();

      // setTimeout(() => {
      //   setToastPop(false);

      //   setTimeout(() => {
      //     setPopUpTitle("");
      //     setMessage("");
      //   }, 3000);
      // }, 5000);
    }
  }, []);
  useEffect(() => {
    if (accountData) {
      setUsername(accountData.loginUsername);
      setPassword(accountData.loginPassword);
    }
  }, [accountData]);

  return (
    <div
      onClick={offItem ? () => setClose(false) : null}
      style={{
        position: "fixed",
        height: "100%",
        width: "100%",
        backgroundColor: "#00000000",
        zIndex: 400,
        left: 0,
        top: 0,
      }}
    >
      {requestPasswordPopUp ? (
        <div
          onMouseOut={() => setOffItem(true)}
          onMouseOver={() => setOffItem(false)}
          style={{
            //   height: 300,
            width: 300,
            backgroundColor: colors.white,
            position: "absolute",
            top: 65,
            right: 20,
            borderRadius: 4,
            WebkitBoxShadow: "0px 0px 7px 2px #00000030",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 10,
          }}
        >
          <div
            style={{
              marginTop: 45,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "80%", marginTop: 20, fontSize: 18 }}>
              You will need to input your main agency admin user password you
              use to access the platform to unlock the the password
            </div>
          </div>
          <div>
            <TextInputField
              labelTitle={"PASSWORD"}
              mini={true}
              value={passwordCheck}
              onChange={(e) => setPasswordCheck(e.target.value)}
              type={"password"}
            />
          </div>
          <div
            style={{
              width: "80%",
              marginTop: 20,
              display: "flex:",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <BaseButtons
              label={"SUBMIT"}
              backgroundColor={colors.primaryBlue}
              borderRadius={4}
              width={"100%"}
              onClick={() => showPassword()}
            />
          </div>

          <div
            style={{
              position: "absolute",
              top: 10,
              left: 10,
              display: "flex",
              alignItems: "center",
            }}
          >
            <BaseButtons
              label={"X"}
              backgroundColor={colors.orangeDark}
              onClick={() => setRequestPasswordPopUp(false)}
              width={30}
              height={30}
              borderRadius={4}
            />{" "}
            <div style={{ fontWeight: "bold", marginLeft: 10 }}>
              PASSWORD REQUEST
            </div>
          </div>
        </div>
      ) : (
        <div
          onMouseOut={() => setOffItem(true)}
          onMouseOver={() => setOffItem(false)}
          style={{
            //   height: 300,
            width: 300,
            backgroundColor: colors.white,
            position: "absolute",
            top: 65,
            right: 20,
            borderRadius: 4,
            WebkitBoxShadow: "0px 0px 7px 2px #00000030",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 10,
          }}
        >
          <div
            style={{
              marginTop: 45,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {accountData ? (
              <TextInputField
                labelTitle={"USERNAME"}
                mini={true}
                value={username}
              />
            ) : (
              <div style={{ width: "80%", marginTop: 20, fontSize: 18 }}>
                Create account to acctivate your mobile scanner user to allow
                for vehicles to be scanned in to your list.
              </div>
            )}
          </div>
          <div>
            {" "}
            {accountData ? (
              <TextInputField
                labelTitle={"PASSWORD"}
                mini={true}
                value={password}
                type={
                  passwordSecure
                    ? passwordSecure
                      ? passwordSecure.success
                      : "password"
                    : "password"
                }
              />
            ) : null}
          </div>
          <div
            style={{
              width: "80%",
              marginTop: 20,
              display: "flex:",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            {accountData ? (
              <BaseButtons
                label={"SHOW PASSWORD"}
                backgroundColor={colors.primaryBlue}
                borderRadius={4}
                width={"100%"}
                onClick={() => setRequestPasswordPopUp(true)}
              />
            ) : (
              <BaseButtons
                label={"CREATE ACCOUNT"}
                backgroundColor={colors.primaryBlue}
                borderRadius={4}
                width={"100%"}
                onClick={() => createNewScannerAccount()}
              />
            )}
          </div>

          <div
            style={{
              position: "absolute",
              top: 10,
              left: 10,
              display: "flex",
              alignItems: "center",
            }}
          >
            <BaseButtons
              label={"X"}
              backgroundColor={colors.orangeDark}
              onClick={() => setClose(false)}
              width={30}
              height={30}
              borderRadius={4}
            />{" "}
            <div style={{ fontWeight: "bold", marginLeft: 10 }}>
              SCANNER ACCOUNT
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountScannerPopUp;
